import { Skeleton } from '@epilot/concorde-elements'

import classes from '../Skeleton.module.scss'

export const SingleInputFieldSkeleton = () => {
  return (
    <div className={classes.root}>
      {/* Mimics one input field */}
      <div className={classes.gridColumn}>
        <Skeleton className={classes.inputSize}>&nbsp;</Skeleton>
      </div>
    </div>
  )
}
